var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"objects-container"},[_c('img',{staticClass:"objects-bg",attrs:{"src":require('@/assets/index/objects-bg.png'),"alt":"objects"}}),_c('div',{staticClass:"main-content"},[_c('p',{domProps:{"innerHTML":_vm._s(_vm.object)}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }